module.exports = __webpack_public_path__ + "static/media/47.ad2c0729.jpg";